/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Programmatic_Seo_Pages_Title5Inputs */

const en_svc_programmatic_seo_pages_title5 = /** @type {(inputs: Svc_Programmatic_Seo_Pages_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Templated page generation`)
};

const ar_svc_programmatic_seo_pages_title5 = /** @type {(inputs: Svc_Programmatic_Seo_Pages_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`توليد الصفحات بالقوالب`)
};

const bn_svc_programmatic_seo_pages_title5 = /** @type {(inputs: Svc_Programmatic_Seo_Pages_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`টেমপ্লেটে পৃষ্ঠা তৈরি`)
};

const de_svc_programmatic_seo_pages_title5 = /** @type {(inputs: Svc_Programmatic_Seo_Pages_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorlagenbasierte Seitengenerierung`)
};

const es_svc_programmatic_seo_pages_title5 = /** @type {(inputs: Svc_Programmatic_Seo_Pages_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generación de páginas con plantillas`)
};

const fr_svc_programmatic_seo_pages_title5 = /** @type {(inputs: Svc_Programmatic_Seo_Pages_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Génération de pages sur modèles`)
};

const pt_svc_programmatic_seo_pages_title5 = /** @type {(inputs: Svc_Programmatic_Seo_Pages_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geração de páginas com modelos`)
};

const zh_svc_programmatic_seo_pages_title5 = /** @type {(inputs: Svc_Programmatic_Seo_Pages_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`模板化批量建页`)
};

const tr_svc_programmatic_seo_pages_title5 = /** @type {(inputs: Svc_Programmatic_Seo_Pages_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şablonla sayfa üretimi`)
};

const ru_svc_programmatic_seo_pages_title5 = /** @type {(inputs: Svc_Programmatic_Seo_Pages_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Генерация страниц по шаблонам`)
};

const pl_svc_programmatic_seo_pages_title5 = /** @type {(inputs: Svc_Programmatic_Seo_Pages_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szablonowa generacja stron`)
};

/**
* | output |
* | --- |
* | "Templated page generation" |
*
* @param {Svc_Programmatic_Seo_Pages_Title5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_programmatic_seo_pages_title5 = /** @type {((inputs?: Svc_Programmatic_Seo_Pages_Title5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Programmatic_Seo_Pages_Title5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_programmatic_seo_pages_title5(inputs)
	if (locale === "bn") return bn_svc_programmatic_seo_pages_title5(inputs)
	if (locale === "de") return de_svc_programmatic_seo_pages_title5(inputs)
	if (locale === "es") return es_svc_programmatic_seo_pages_title5(inputs)
	if (locale === "fr") return fr_svc_programmatic_seo_pages_title5(inputs)
	if (locale === "pt") return pt_svc_programmatic_seo_pages_title5(inputs)
	if (locale === "zh") return zh_svc_programmatic_seo_pages_title5(inputs)
	if (locale === "tr") return tr_svc_programmatic_seo_pages_title5(inputs)
	if (locale === "ru") return ru_svc_programmatic_seo_pages_title5(inputs)
	if (locale === "pl") return pl_svc_programmatic_seo_pages_title5(inputs)
	return en_svc_programmatic_seo_pages_title5(inputs)
});
export { svc_programmatic_seo_pages_title5 as "svc_programmatic-seo_PAGES_title" }